<app-unified-header [title]="!wearerId ? 'Add Wearer' : isReadMode ? 'Wearer Details' : 'Edit Wearer'"
  (onSave)="isReadMode ? setEditMode(true) : manageWearer(wearerId ? 'put': 'post')" defaultHref="/wearer-list"
  [restrictBack]="wearerDetailsForm && !wearerDetailsForm.pristine"
  [saveBtn]="{title: wearerId && isReadMode ? 'Edit' : 'Save', isDisable: wearerId && isReadMode ? (isPCCEnabled && isResident && f['wearerStatus']?.value ? true : false) : isSaveDisabled, rule: wearerId ? 'putWearer' : ''}"
  [isRootPage]="isRootPage"></app-unified-header>

<ion-content *ngIf="wearerDetailsForm">
  <form [formGroup]="wearerDetailsForm">
    <div class="detail-block-1" *ngIf="!isPCCEnabled || (isPCCEnabled && (isReadMode || !wearerId || !isResident))">
      <div class="section-label first-record">Wearer Information <ion-icon *ngIf="isPCCEnabled && wearerId"
          class="entity-info-icon" src="assets/icon/icons_Hint.svg"
          (click)="onInfo($event, 'Resident information is currently managed through your EHR.')"></ion-icon></div>
      <ng-container *ngFor="let config of wearerDetailsInputConfig">
        <unified-input ngDefaultControl [formControlName]="config.name || null" [config]="getConfig(config)"
          (changed)="inputChanged($event)"></unified-input>
      </ng-container>
      <ion-item *ngIf="!(wearerId && !isReadMode)">
        <ion-label slot="start" class="select-label">Wearer Group</ion-label>
        <ion-select slot="end" formControlName="wearerGroupId">
          <ion-select-option *ngFor="let group of storedGroups" [value]="group.id">{{group.label}}</ion-select-option>
        </ion-select>
      </ion-item>
      <!-- <ion-item></ion-item> -->
      <ion-item>
        <ion-label slot="start" class="select-label">Wearer Status</ion-label>
        <ion-select slot="end" (ionChange)='changeStatus($event)' formControlName="wearerStatus"
          [disabled]="isReadMode">
          <ion-select-option *ngFor="let status of wearerStatus"
            [value]="status.value">{{status.name}}</ion-select-option>
        </ion-select>
      </ion-item>
    </div>
    <ng-container *ngIf="wearerId">
      <div class="room-block" *ngIf="isResident && (!isPCCEnabled || (isPCCEnabled && isReadMode))">
        <ion-item class="form-item-detail first-item-border" *ngIf="!isReadMode && !roomDisabled" detail
          (click)="setRoom()">
          <ion-label>Room</ion-label>
          <ion-text slot="end" [class.none-value]="!f['roomName']?.value">{{f['roomName']?.value ||
            'None'}}</ion-text>
        </ion-item>
        <ion-item class="form-item-detail first-item-border" detail="false"
          *ngIf="isReadMode && showRoom && !roomDisabled">
          <ion-label>
            <h3 class="room-name">
              <p class="slot-1">Room <ion-icon *ngIf="isPCCEnabled" class="entity-info-icon"
                  src="assets/icon/icons_Hint.svg"
                  (click)="onInfo($event, 'Room assignments are currently managed through your EHR.')"></ion-icon>
              </p>
              <p class="slot-2" *ngIf="isEtectRxEnabled && hasValidEtectId">eBrief Tag ID:
                {{f['etectDetails.etectId']?.value}}</p>
            </h3>
            <p
              *ngIf="isCasparEnabled && !wearerDetails?.beds?.[0]?.deviceDetails?.macId && wearerDetails?.rooms?.[0]?.deviceDetails?.macId">
              Caspar Vitals Sensor
              Installed<span *ngIf="isDeviceManagementEnabled">:
                <span (click)="navigateToDeviceManagement(wearerDetails?.rooms?.[0]?.deviceDetails)"
                  [ngClass]="{'app-link': isDeviceManagementEnabled }">{{wearerDetails?.rooms?.[0]?.deviceDetails?.macId}}</span></span>
            </p>
          </ion-label>
          <ion-text slot="end" [color]="wearerDetails?.rooms?.[0] ? 'ok' : 'dark-text'"
            (click)="navigateToRoomDetails()"
            [ngClass]="{'app-link': wearerDetails?.rooms?.[0]?.roomName, 'no-link': !isRoomSummaryEnabled}"
            [class.none-value]="!wearerDetails?.rooms?.[0]?.roomName">{{(wearerDetails?.rooms?.[0]?.roomName)
            ||
            'Unassigned'}}<span
              *ngIf="wearerDetails?.rooms?.[0]?.roomName && wearerDetails?.residentDetail?.slotName && isBedSlotEnabled">-{{
              wearerDetails?.residentDetail?.slotName
              }}</span></ion-text>
        </ion-item>
        <ion-item class="form-item-detail" *ngIf="isReadMode && showRoom && !roomDisabled">
          <ion-label>
            <h3>Bed</h3>
            <p *ngIf="isCasparEnabled && wearerDetails?.beds?.[0]?.deviceDetails?.macId">
              Caspar Vitals Sensor
              Installed<span *ngIf="isDeviceManagementEnabled">:
                <span (click)="navigateToDeviceManagement(wearerDetails?.beds?.[0]?.deviceDetails)"
                  [ngClass]="{'app-link': isDeviceManagementEnabled}">{{wearerDetails?.beds?.[0]?.deviceDetails?.macId}}</span></span>
            </p>
          </ion-label>
          <ion-text slot="end" [color]="wearerDetails?.beds?.[0] ? 'ok' : 'dark-text'" (click)="navigateToBedDetails()"
            [ngClass]="{'app-link': wearerDetails?.beds?.[0]?.bedName, 'no-link': !isBedSummaryEnabled}"
            [class.none-value]="!wearerDetails?.beds?.[0]?.bedName">{{(wearerDetails?.beds?.[0]?.bedName)
            ||
            'Unassigned'}}</ion-text>
        </ion-item>
        <!-- <ion-item class="form-item-detail" *ngIf="!isReadMode && !roomDisabled" (click)="selectBed()" detail>
          <ion-label>Bed</ion-label>
          <ion-text slot="end"
            [class.none-value]="!wearerDetails?.beds?.[0]?.bedName">{{(wearerDetails?.beds?.[0]?.bedName) ||
            'Unassigned'}}</ion-text>
        </ion-item> -->
        <ion-note class="replace-note" *ngIf="isReadMode">Assign, change, or remove a bed from the room in Bed
          Management</ion-note>
        <ion-item class="form-item-detail indent-item-detail" [detail]="!isReadMode"
          [ngClass]="{'interactive': !isReadMode}" (click)="setBedSlot()" [disabled]="!f['roomName']?.value"
          *ngIf="isBedSlotEnabled && !isReadMode">
          <ion-label>Bed Slot</ion-label>
          <ion-text slot="end" [class.none-value]="!f['slotName']?.value">{{f['slotName']?.value ||
            'None'}}</ion-text>
        </ion-item>
      </div>

      <ng-container *ngIf="isResident && wearerAlerts.length && !f['wearerStatus']?.value">
        <div class="section-label">Alerts</div>
        <div *ngFor="let alert of wearerAlerts">
          <ion-item>
            <ion-label>{{alert.label}}</ion-label>
            <ion-toggle mode="ios" color="controls" slot="end" [formControlName]="'alertSettings.'+alert.key"
              *ngIf="!isReadMode" (ionChange)="onAlertToggle($event, alert.key)"></ion-toggle>
            <div slot="end" class="custom-input ion-text-right" *ngIf="isReadMode">
              <ion-input class="toggle-input-text" [value]="f['alertSettings.'+alert.key]?.value ? 'Yes' : 'No'"
                readonly></ion-input>
            </div>
          </ion-item>
          <div *ngIf="f['alertSettings.'+alert.key]?.value">
            <ion-item *ngFor="let alert1 of alert.alerts">
              <ion-label class="bed-alert-label select-label">{{alert1.label}}</ion-label>
              <ion-select slot="end" aria-label="Choose" placeholder="Choose" (ionChange)="handleAlertChange($event)"
                [formControlName]="'alertSettings.'+alert1.key" interface="popover" [disabled]="isReadMode">
                <ion-select-option *ngFor="let alertData of alert1.datasetcsv"
                  [value]="alertData.key">{{alertData.displayName}}</ion-select-option>
              </ion-select>
            </ion-item>
          </div>
        </div>
      </ng-container>

<!-- Show if etect is enabled for facility AND is a resident AND if active AND (read mode OR etectId) -->
<ng-container *ngIf="isEtectRxEnabled && isResident && !f['wearerStatus']?.value && (isReadMode || hasValidEtectId)">
  
  <div class="section-label">Incontinence Care</div>
  <div>   
                    
    <ion-item>
      <ion-label>Monitoring</ion-label>
            
      <!-- Toggle: Flat control binding using formControlName -->
      <ion-toggle mode="ios" color="controls" slot="end" 
        [formControlName]="'etectDetails.etectMonitoringStatus'"
        *ngIf="!isReadMode && hasValidEtectId"></ion-toggle>
                    
      <!-- Display text for Read Mode --> 
      <div slot="end" class="custom-input ion-text-right" *ngIf="isReadMode || !hasValidEtectId">
        <ion-input class="toggle-input-text"
          [value]="hasValidEtectId ? (f['etectDetails.etectMonitoringStatus']?.value ? 'Enabled' : 'Disabled') : 'Unavailable'"
          readonly></ion-input>
      </div> 
    </ion-item>
                    
    <!-- Helper Note -->
    <ion-note class="replace-note" *ngIf="!hasValidEtectId">
      Assign the resident to a bed slot with a Tag ID to access the incontinence feature.
    </ion-note>

    <!-- Alerts Control Item: Checks boolean directly set in createForm() -->
    <ion-item *ngIf="hasValidEtectId && f['etectDetails.etectMonitoringStatus']?.value">
      <ion-label>Alerts</ion-label>

      <ion-toggle mode="ios" color="controls" slot="end"
        [formControlName]="'etectDetails.etectAlertStatus'"
        *ngIf="!isReadMode"></ion-toggle>

      <div slot="end" class="custom-input ion-text-right" *ngIf="isReadMode">
        <ion-input class="toggle-input-text"
          [value]="f['etectDetails.etectAlertStatus']?.value ? 'On' : 'Paused'"
          readonly></ion-input>
      </div>
    </ion-item>

  </div>    
</ng-container>



      <div class="wearer-item band" *ngIf="isReadMode && !roomDisabled">
        <div class="section-label">Device</div>

        <ion-item *ngFor="let band of wearerDetails?.bands" (click)="findBand(band)" detail class="first-item-border">
          <ion-label>{{band?.isTag ? 'ONDO Tag' : 'ONDO Band'}}</ion-label>
          <div slot="end" class="band-id">
            <ion-text> {{band?.bandId || band?.tagId}}</ion-text>
          </div>
        </ion-item>
        <ion-note class="replace-note" *ngIf="wearerDetails?.bands?.length">Access device-specific settings, or replace
          or remove any associated devices from this wearer.</ion-note>
        <ion-note class="replace-note" *ngIf="!wearerDetails?.bands?.length && !isNative">To add or replace a Band/Tag,
          use the mobile app.</ion-note>
        <ion-item detail (click)="findBand()" class="first-item-border"
          *ngIf="!wearerDetails?.bands?.length && isNative">
          <ion-label class="app-link-action">Assign Devices...</ion-label>
        </ion-item>
      </div>
    </ng-container>
  </form>
  <div class="delete-wearer" *ngIf="isReadMode && (!isPCCEnabled || (isPCCEnabled && !isResident))">
    <ion-button color="danger" (click)="deleteWearer()" [nAccess]="'deleteWearer'">Delete This
      Wearer</ion-button>
  </div>
</ion-content>
